import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	createTitle: {
		id: 'eoc.escalation-policies.ui.escalation-policy-modal.create-title.no-translate',
		defaultMessage: 'Create escalation policy',
		description: 'Title of create an escalation modal',
	},
	editTitle: {
		id: 'eoc.escalation-policies.ui.escalation-policy-modal.edit-title.no-translate',
		defaultMessage: 'Edit escalation policy',
		description: 'Title of edit an escalation modal',
	},
	cloneTitle: {
		id: 'eoc.escalation-policies.ui.escalation-policy-modal.clone-title.no-translate',
		defaultMessage: 'Duplicate escalation policy',
		description: 'Title of create an escalation modal',
	},
	cancel: {
		id: 'eoc.escalation-policies.ui.escalation-policy-modal.cancel.no-translate',
		defaultMessage: 'Cancel',
		description: 'Label of cancel button',
	},
	create: {
		id: 'eoc.escalation-policies.ui.escalation-policy-modal.create.no-translate',
		defaultMessage: 'Create',
		description: 'Label of create button',
	},
	clone: {
		id: 'eoc.escalation-policies.ui.escalation-policy-modal.clone.no-translate',
		defaultMessage: 'Duplicate',
		description: 'Label of clone button',
	},
	update: {
		id: 'eoc.escalation-policies.ui.escalation-policy-modal.update.no-translate',
		defaultMessage: 'Save',
		description: 'Label of update button',
	},
	infoSection: {
		id: 'eoc.escalation-policies.ui.escalation-policy-modal.info-section-title.no-translate',
		defaultMessage: `The
    {deletedEntityCount, plural,
      one {responder}
      other {responders}
    }
     you added no longer exists. Select another one.
    `,
		description: 'Informative text in the info section for deleted entity',
	},
});

export default messages;
